// Convert "can_view" → "View"
const formatPermissionKey = (key) => {
  return key
    .replace("can_", "") // remove prefix
    .replace("_", " ") // replace underscore
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize
};

// Convert "dashboard" → "Dashboard"
const formatModuleName = (module) => {
  return module.replace(/\b\w/g, (c) => c.toUpperCase());
};

// Pick the English / Arabic label, falling back to a formatted key
const getModuleLabel = (item, isArabic) =>
  (isArabic ? item.moduleLabelAr : item.moduleLabel) ||
  item.moduleLabel ||
  formatModuleName(item.module);

const getPermissionLabel = (perm, isArabic) => {
  if (typeof perm === "string") return formatPermissionKey(perm);
  return (
    (isArabic ? perm.labelAr : perm.label) ||
    perm.label ||
    formatPermissionKey(perm.key)
  );
};

// Build readable permission string
export const formatPermissions = (permissions, language) => {
  if (!permissions || permissions.length === 0) return "—";

  const isArabic = language === "ar";

  return permissions
    .map((item) => {
      const moduleName = getModuleLabel(item, isArabic);
      const perms = (item.permissions || [])
        .map((perm) => getPermissionLabel(perm, isArabic))
        .join(isArabic ? "، " : ", ");

      return `${moduleName}: ${perms}`;
    })
    .join(" | ");
};

// Preferred column order; any other keys follow in the order they appear
const PERMISSION_ORDER = ["can_view", "can_create", "can_edit", "can_delete"];

// Build { columns, rows } for the permissions matrix modal
export const buildPermissionMatrix = (permissions, language) => {
  const isArabic = language === "ar";
  const columnMap = new Map();

  const rows = (permissions || []).map((item) => {
    const granted = new Set();

    (item.permissions || []).forEach((perm) => {
      const key = typeof perm === "string" ? perm : perm.key;
      granted.add(key);
      if (!columnMap.has(key)) {
        columnMap.set(key, getPermissionLabel(perm, isArabic));
      }
    });

    return {
      module: item.module,
      label: getModuleLabel(item, isArabic),
      granted,
    };
  });

  const rank = (key) => {
    const index = PERMISSION_ORDER.indexOf(key);
    return index === -1 ? PERMISSION_ORDER.length : index;
  };

  const columns = [...columnMap.entries()]
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => rank(a.key) - rank(b.key));

  return { columns, rows };
};

export const hasAtLeastOneViewPermission = (permissions, selected) => {
  return permissions?.some((module) =>
    selected[module.module]?.some((permKey) =>
      permKey.toLowerCase().includes("view")
    )
  );
};
